import { type FunctionDeclaration, SchemaType } from "@google/generative-ai";
import axios from "axios";
export const FunctionDeclarations: {
declaration: FunctionDeclaration;
function: (args: any) => Promise<any>;
}[] = [
{
declaration: {
name: "getDateInfo",
parameters: {
type: SchemaType.OBJECT, 
description: "Returns the current date and time as a string.",
properties: {
timestring: {
type: SchemaType.STRING, 
description: "Any string. Has no effect on the timing process.",
},
},
required: [],
},
},
function: async () => {
return new Date().toString();
},
},
{
declaration: {
name: "changeVoice",
parameters: {
type: SchemaType.OBJECT,
description: "Changes the voice used and stores it in local storage. after changing the voice inform the user to refresh the page inorder the voice to take effect",
properties: {
name: {
type: SchemaType.STRING,
description: "The new voice name.",
enum: ["Puck", "Charon", "Kore", "Fenrir", "Aoede"],
},
},
required: ["name"],
},
},
function: async (args: any) => {
const { name } = args;
localStorage.setItem("voicename", name);
return `Voice changed to ${name}. Please refresh the page and start a new conversation.`;
},
},
{
declaration: {
name: "fetchURL",
parameters: {
type: SchemaType.OBJECT,
description: "Fetches data from the specified URL.",
properties: {
url: {
type: SchemaType.STRING,
description: "The URL to fetch."
}
},
required: ["url"]
}
},
function: async (args: any): Promise<any> => {
const { url } = args;
const response = await axios.get(url);
return response.data;
}
},
{
declaration: {
name: "getWeather",
parameters: {
type: SchemaType.OBJECT,
description: "Fetches weather data for the specified location.",
properties: {
location: {
type: SchemaType.STRING,
description: "US Zipcode, UK Postcode, Canada Postalcode, IP address, Latitude/Longitude, or city name."
}
},
required: ["location"]
}
},
function: async (args: any): Promise<any> => {
const { location } = args;
const apiKey = "ad0444d726014039b1e65355240402";
const url = `https://api.weatherapi.com/v1/current.json?key=${apiKey}&q=${encodeURIComponent(location)}&aqi=yes`;
try {
const response = await axios.get(url);
return response.data;
} catch (error) {
return { error: "Failed to fetch weather data. Check location input." };
}
}
},
{
declaration: {
name: "getLocation",
parameters: {
type: SchemaType.OBJECT,
description: "Fetches the current geographic location of the user.",
properties: {
mode: {
type: SchemaType.STRING,
description: "must always browser-based"
}
},
required: []
}
},
function: async (): Promise<any> => {
return new Promise((resolve, reject) => {
if ("geolocation" in navigator) {
navigator.geolocation.getCurrentPosition(
(position) => {
resolve({
latitude: position.coords.latitude,
longitude: position.coords.longitude,
});
},
() => {
reject({ error: "Geolocation permission denied or unavailable." });
}
);
} else {
reject({ error: "Geolocation is not supported by this browser." });
}
});
}
}
];